import React, { memo } from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import { useTranslation } from 'react-i18next';

const WarehouseName = memo(({ name }: WarehouseNameColumnTemplateData) => {
    const { t } = useTranslation('WarehouseName');

    const translations: { [key: string]: string } = t('names', {
        returnObjects: true,
    });

    const transformedName = name ? translations[name] || name : name;

    return <>{transformedName}</>;
});

const WarehouseNameColumnTemplate = (props: CellTemplateProps) => {
    const data = gridCellData(props);

    return (
        <>
            <WarehouseName name={data} />
        </>
    );
};

export const WarehouseNameColumnTemplateDefaultProps = {};

export const WarehouseNameColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type WarehouseNameColumnTemplateData = { name?: string };

export const WarehouseNameColumnTemplateDataKeys = ['name'];

export default WarehouseNameColumnTemplate;
